export default __webpack_public_path__ + "static/media/featured_area_markham.729c6140.png";